import { MatcherName, registerLocallyHandledErrorMatcher, singleErrorMatcher, } from '../api/locallyHandledErrors';
import i18n from '../i18n';
export const errorMatcher = singleErrorMatcher({ message: 'ProductAssignedException' });
export const assignedProductErrorHandler = (translationKey) => (error) => {
    if (errorMatcher(error)) {
        // eslint-disable-next-line no-console
        console.error(i18n.t(`exceptions:${translationKey}`));
    }
    throw error;
};
export const assignedProductErrorIgnorer = (error) => {
    if (!errorMatcher(error)) {
        throw error;
    }
};
export const registerAssignedProductErrorMatcher = () => registerLocallyHandledErrorMatcher(MatcherName.ProductAssignedException, errorMatcher);
